module.exports = __webpack_public_path__ + "img/locked.a0165d16.png";